import { mui } from '@local/finsera-core/src/libs';

const FinFilterTrigger = () => {
  return (
    <mui.dataGrid.FilterPanelTrigger
      render={
        <mui.dataGrid.ToolbarButton
          render={
            <mui.core.Button type="button" size="small" startIcon={<mui.icons.FilterList fontSize="small" />}>
              Filters
            </mui.core.Button>
          }
        />
      }
    />
  );
};

export default FinFilterTrigger;
